import { axiosInstance, requestConfig } from 'network/apis';

import { URL_GAME } from 'utils/constants';

export const callTournamentDetails = async (tournamentId) => {
    return await axiosInstance(requestConfig('get', URL_GAME, `/tournament/${tournamentId}/details`));
};

export const callTournamentRanking = async (tournamentId, recordType, coruseId, data) => {
    return await axiosInstance(requestConfig('get', URL_GAME, `/tournament/${tournamentId}/kms-ranking/${recordType}/${coruseId}`, data));
};

export const callTournamentTotalRanking = async (tournamentId, recordType, data) => {
    return await axiosInstance(requestConfig('get', URL_GAME, `/tournament/${tournamentId}/kms-total-ranking/${recordType}`, data));
};

export const callTournamentAwardRecipientsList = async (tournamentId) => {
    return await axiosInstance(requestConfig('get', URL_GAME, `/tournament/${tournamentId}/kms-award-recipients`));
};

export const callExceptTournamentParticipantsCourseAward = async (tournamentId, recordType, tournamentParticipantId, data) => {
    return await axiosInstance(requestConfig('put', URL_GAME, `/tournament/${tournamentId}/award/course/${recordType}/${tournamentParticipantId}/except`, data));
};

export const callExceptTournamentParticipantsTotalAward = async (tournamentId, recordType, userGuid, data) => {
    return await axiosInstance(requestConfig('put', URL_GAME, `/tournament/${tournamentId}/award/total/${recordType}/${userGuid}/except`, data));
};

export const callTournamentParticipantAdditionalHandicapSettings = async (tournamentId, recordType, tournamentParticipantId, data) => {
    return await axiosInstance(requestConfig('put', URL_GAME, `/tournament/${tournamentId}/award/course/${recordType}/${tournamentParticipantId}/handicap`, data));
};

export const callResetTournamentAwards = async (tournamentId) => {
    return await axiosInstance(requestConfig('put', URL_GAME, `/tournament/${tournamentId}/award/reset`));
};

export const calltournamentAwardRecipientsSelection = async (tournamentId) => {
    return await axiosInstance(requestConfig('post', URL_GAME, `/tournament/${tournamentId}/award/recipients-selection`));
};

export const callTournamentAwardAnnouncement = async (tournamentId, data) => {
    return await axiosInstance(requestConfig('put', URL_GAME, `/tournament/${tournamentId}/award/announcement`, data));
};
